import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
//components
import Select from "../../../components/input/Select";
import NumberInput from "../../../components/input/NumberInput";
//services
import { onSubmitCurrentAccount } from "../../../services/CurrentAccount/onSubmitCurrentAccount";
//utils
import { banks } from "../../../utils/banks";
import { useState } from "react";
import { useMutation } from "react-query";
import { queryClient } from "../../../utils/queryClient";

const ModalCreateCurrentAccount = ({
  visible,
  owners,
  setVisible,
  loadingAccount,
  refresh,
}) => {
  const {
    control: controlAccount,
    handleSubmit: handleAccount,
    reset: resetAccount,
    formState: { errorsAccount },
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  const { mutateAsync: postCurrentAccountFn } = useMutation({
    mutationFn: onSubmitCurrentAccount,
    onSuccess(currentAccount) {
      queryClient.invalidateQueries(["current-account"]);
    },
    onError(error) {
      console.log(error);
    },
  });



  async function sendCurrentAccount(data) {
    const notification = toast.loading("Por favor aguarde...");
    if(!data.opening_balance) {
      data.opening_balance = 0;
    }
    setIsLoading(true);
    try {
      await postCurrentAccountFn(data);
      toast.update(notification, {
        render: "Conta Corrente cadastrada com sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.error("Erro ao enviar a conta corrente:", error);
      toast.update(notification, {
        render: "Não foi possível realizar o cadastro",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      setIsLoading(false);
      setVisible(false);
      resetAccount();
    }
  }


  return (
    <>
      <Dialog
        header="Cadastrar Conta Corrente"
        id="modal_cad"
        className="rounded-4"
        onHide={() => setVisible(false)}
        visible={visible}
        style={{ width: window.innerWidth <= 992 ? "85vw" : "70vw" }}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Informações da conta corrente</b>
          </div>
        </Divider>
        <form onSubmit={handleAccount(sendCurrentAccount)}>
          <div className="px-3">
            <div className="row">
              <div className="col-md-6 mb-3 form-group">
                <Select
                  isRequired={true}
                  id="bank"
                  name="bank"
                  errors={errorsAccount}
                  control={controlAccount}
                  options={banks}
                  label="Banco"
                  optionLabel="label"
                  optionValue="value"
                  style={{ marginTop: "1.5rem" }}
                />
              </div>
              <div className="col-md-6 mb-4 form-group">
                <Select
                  isRequired={true}
                  id="user_id"
                  name="user_id"
                  errors={errorsAccount}
                  control={controlAccount}
                  options={owners}
                  label="Empresa"
                  optionLabel="name"
                  optionValue="id"
                  style={{ marginTop: "1.5rem" }}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  required={true}
                  maxLength={15}
                  control={controlAccount}
                  name="agency"
                  label="Agência"
                  id="agency"
                />
              </div>
              <div className="col-xl-2 col-md-4">
                <NumberInput
                  required={true}
                  maxLength={15}
                  control={controlAccount}
                  name="agency_digit"
                  label="Dig. Agência"
                  id="agency_digit"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  required={true}
                  maxLength={15}
                  control={controlAccount}
                  name="account_number"
                  label="Nº da Conta"
                  id="account_number"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  required={true}
                  maxLength={15}
                  defaultValue=""
                  control={controlAccount}
                  name="account_digit"
                  label="Dígito Conta"
                  id="account_digit"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  className="w-100"
                  required={true}
                  maxLength={15}
                  max={89}
                  control={controlAccount}
                  name="days_to_clean"
                  label="Dias para Baixa"
                  id="days_to_clean"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-4 form-group">
                <NumberInput
                  suffix={""}
                  mode="currency"
                  maxLength={15}
                  currency="BRL"
                  locale="pt-BR"
                  useGrouping={true}
                  placeholder={"0"}
                  max={undefined}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  className="w-100"
                  control={controlAccount}
                  name="opening_balance"
                  label="Saldo Inicial"
                  id="opening_balance"
                />
              </div>

              <div className="text-center">
                <Button
                  rounded
                  label="Cadastrar"
                  icon="fa fa-plus"
                  type="submit"
                  className="p-inputtext-sm m-auto"
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalCreateCurrentAccount;
